export function formatCampaignDay(day: number): string {
  return String(day).padStart(2, '0');
}
